export function myPlaginDebounce(fn, delay) {
  let timeoutID = null;
  return function () {
    clearTimeout(timeoutID);
    const args = arguments;
    const that = this;
    timeoutID = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}
export function myPlaginFilterDirectory(array) {
  let title = '';
  if (Array.isArray(array) && array.length == 0) {
    title = '-';
    return title;
  }
  if (Array.isArray(array) && array.length > 0) {
    array.forEach((el, index) => {
      if (
        el.dictionary &&
        el.dictionary.parent &&
        el.dictionary.parent.parent === null
      ) {
        title += `${el.dictionary.title}`;
      }
      if (
        el.dictionary &&
        el.dictionary.parent &&
        el.dictionary.parent.parent !== null
      ) {
        title += `${el.dictionary.title}:${el.dictionary.parent.title}`;
      }
      if (index < array.length - 1) {
        title += ',';
      }
    });
  }
  return title;
}
export function myPlaginFilterParents(array) {
  let title = '';
  if (Array.isArray(array) && array.length == 0) {
    title = '-';

    return title;
  }
  if (Array.isArray(array) && array.length > 0) {
    array.forEach((el, index) => {
      if (
        el.dictionary &&
        el.dictionary.parent &&
        el.dictionary.parent.parent === null
      ) {
        title += `${el.dictionary.title}`;
      }
      if (
        el.dictionary &&
        el.dictionary.parent &&
        el.dictionary.parent.parent !== null
      ) {
        title += `${el.dictionary.title}:${el.dictionary.parent.title}`;
      }
      if (index < array.length - 1) {
        title += ',';
      }
    });
  }
  const maxLength = 10;
  if (title.length > maxLength) {
    // Обрезаем текст до максимальной длины и добавляем троеточие
    const truncatedTitle = `${title.slice(
      0,
      maxLength
    )}<span class='attr-blue'>...</span>`;
    return `<span  title="${title}">${truncatedTitle}</span >`;
  } else {
    return title;
  }
}
export function myPlaginWeekDay(day) {
  const date = new Date(day);
  const weekDay = [
    ' יום א׳',
    'יום ב׳',
    'יום ג׳',
    'יום ד׳',
    'יום ה׳',
    'יום ו׳',
    'שבת'
  ];
  return weekDay[date.getDay()];
}
export const myPlaginPropsTelInput = {
  mode: 'international',
  disabledFetchingCountry: false,
  disabled: false,
  disabledFormatting: false,
  placeholder: 'Enter a phone number',
  required: false,
  enabledCountryCode: true,
  enabledFlags: true,
  preferredCountries: [],
  onlyCountries: [],
  ignoredCountries: [],
  autocomplete: 'on',
  name: 'telephone',
  maxLen: 25,
  wrapperClasses: '',
  inputClasses: '',
  inputOptions: {
    showDialCode: true
  }
};

export default {
  myPlaginDebounce,
  myPlaginWeekDay,
  myPlaginPropsTelInput
};
